<div class="nav-sidebar-container">
  <!-- Mobile overlay -->
  <div *ngIf="mobileOpen" class="mobile-overlay" (click)="mobileClose.emit()"></div>

  <div class="sidebar-wrapper" [class.mobile-open]="mobileOpen">
    <!-- Logo -->
    <div class="logo-section">
      <img src="assets/images/chevron-logo.png" alt="Chevron" />
    </div>

    <!-- New Chat button (overview mode only) -->
    <button *ngIf="showNavItems" (click)="newChat.emit()" class="new-chat-button">
      <span class="plus-icon">+</span> New Chat
    </button>

    <!-- User Metrics button - Show only if user has access -->
    <button *ngIf="hasMetricsAccess()" (click)="metricsClick.emit()" class="metrics-button">
      <img src="assets/images/userMetrics.png" alt="Metrics" class="metrics-icon" />
      <span>User Metrics</span>
    </button>

    <!-- Nav items + chat history -->
    <nav class="nav-section" [class.hidden]="!showNavItems">

      <!-- Nav items (overview sidebar) -->
      <ng-container *ngIf="showNavItems">
        <button *ngFor="let item of sidebarSections[0]?.items" type="button"
          (click)="navItemClick.emit(item.id)"
          class="nav-item"
          [class.active]="activeNavItemId === item.id">
          <span class="nav-dot">&#183;</span>
          <span class="nav-label">{{ item.label }}</span>
        </button>
        <div class="chat-history-divider">
          <div class="history-label">Chat History</div>
        </div>
      </ng-container>

      <!-- Chat history label (field / prompt-home mode) -->
      <ng-container *ngIf="!showNavItems">
        <div class="history-label">Chat History</div>
      </ng-container>

      <!-- Chat history entries -->
      <div class="history-list">
        <div *ngIf="loadingHistory" class="history-loading">
          <img src="assets/images/spinner.png" alt="Loading..." class="spinner-icon" />
          <p class="loading-text">Loading history...</p>
        </div>
        <p *ngIf="!loadingHistory && chatHistory.length === 0" class="history-empty">
          No history yet &#8212; ask a question in chat.
        </p>
        <button *ngFor="let c of chatHistory" type="button" (click)="historyClick.emit(c)"
          class="history-item"
          [class.active]="activeHistoryId === c.id">
          <span class="history-icon">&#x1F4AC;</span>
          <span class="history-text" [title]="c.question">{{ truncate(c.question) }}</span>
        </button>
      </div>
    </nav>

    <!-- User profile -->
    <div class="user-profile">
      <div class="profile-box">
        <div class="profile-avatar">
          <img src="assets/images/userIcon.png" alt="User" class="user-icon" />
        </div>
        <div class="profile-info">
          <p class="profile-name">{{ currentUserDisplayName }}</p>
          <p class="profile-role">Well Engineer</p>
        </div>
      </div>
    </div>
  </div>
</div>
